import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import StaffPortal from "@/pages/StaffPortal";
import CustomerTable from "@/pages/CustomerTable";
import StaffDashboard from "@/pages/StaffDashboard";
import StaffOrders from "@/pages/StaffOrders";
import AdminTables from "@/pages/AdminTables";
import AdminMenu from "@/pages/AdminMenu";
import AdminUsers from "@/pages/AdminUsers";
import AdminSettings from "@/pages/AdminSettings";
import AdminRestaurants from "@/pages/AdminRestaurants";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            {/* Client site */}
            <Route path="/" element={<Landing />} />
            <Route path="/t/:code" element={<CustomerTable />} />

            {/* Staff site */}
            <Route path="/staff-portal" element={<StaffPortal />} />
            <Route path="/login" element={<Navigate to="/staff-portal" replace />} />
            <Route path="/staff" element={<ProtectedRoute><StaffDashboard /></ProtectedRoute>} />
            <Route path="/staff/orders" element={<ProtectedRoute><StaffOrders /></ProtectedRoute>} />
            <Route path="/admin/tables" element={<ProtectedRoute adminOnly><AdminTables /></ProtectedRoute>} />
            <Route path="/admin/menu" element={<ProtectedRoute adminOnly><AdminMenu /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/restaurants" element={<ProtectedRoute ownerOnly><AdminRestaurants /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
